import { Dependencies } from "../../types";

export const MOCK_RECURRING_JOURNAL_ENTRIES_DEPENDENCIES: Dependencies = {
  recurring_entry_reference: {
    post_formula_calc_option: {
      rules: [
        {
          matches: ["value"],
          fieldsToEnable: ["posting_amount"],
          fieldsToDisableAndClear: [
            "post_formula_percent",
            "post_formula_store",
            "post_formula_company",
            "post_formula_account",
            "post_formula_balance",
          ],
        },
        {
          matches: ["formula"],
          fieldsToEnable: [
            "post_formula_percent",
            "post_formula_store",
            "post_formula_company",
            "post_formula_account",
            "post_formula_balance",
          ],
          fieldsToDisableAndClear: ["posting_amount"],
        },
        {
          matches: [null],
          fieldsToEnable: [
            "posting_amount",
            "post_formula_percent",
            "post_formula_store",
            "post_formula_company",
            "post_formula_account",
            "post_formula_balance",
          ],
        },
      ],
    },
  },
};

export const MOCK_CHART_OF_ACCOUNTS_DEPENDENCIES: Dependencies = {
  account_type: {
    rules: [
      {
        matches: ["Asset"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: ["Asset", "Equity", "Liability"],
            isForExistingRecord: true,
          },
          {
            targetKey: "sub_type",
            enumValues: ["Vehicle Inventory", "Cash", "Inter-Company", null],
            allowedValues: [
              "Balance-forward Receivable",
              "Balance Fwd - Receivable",
              "Open-Item Receivable",
              "Open-Item Payable",
            ],
          },
        ],
        fieldsToEnable: ["sub_type"],
        fieldsToDisableAndClear: ["unit_analysis_group_code"],
      },
      {
        matches: ["Equity"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: ["Asset", "Equity", "Liability"],
            isForExistingRecord: true,
          },
          {
            targetKey: "sub_type",
            enumValues: ["Profit", "Retained Earnings", null],
          },
        ],
        fieldsToEnable: [
          "sub_type",
          "productivity_type_code",
          "statistical_count_type_code",
          "is_posting_description_required",
        ],
        fieldsToDisableAndClear: [
          "unit_analysis_group_code",
          "control_type_code",
          "control2_type_code",
        ],
      },
      {
        matches: ["Liability"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: ["Asset", "Equity", "Liability"],
            isForExistingRecord: true,
          },
          {
            targetKey: "sub_type",
            enumValues: ["Balance-forward Payable", "Inter-Company", null],
            allowedValues: [
              "Balance-forward Receivable",
              "Balance Fwd - Receivable",
              "Open-Item Receivable",
              "Open-Item Payable",
            ],
          },
        ],
        fieldsToEnable: ["sub_type"],
        fieldsToDisableAndClear: ["unit_analysis_group_code"],
      },
      {
        matches: ["Cost Of Sale"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: [
              "Sale",
              "Cost Of Sale",
              "Operating Expense",
              "Non-operating Expense",
              "Non-operating Income",
            ],
            isForExistingRecord: true,
          },
          {
            targetKey: "sub_type",
            enumValues: [null],
          },
        ],
        fieldsToEnable: ["unit_analysis_group_code"],
        fieldsToDisableAndClear: ["sub_type"],
      },
      {
        matches: ["Sale"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: [
              "Sale",
              "Cost Of Sale",
              "Operating Expense",
              "Non-operating Expense",
              "Non-operating Income",
            ],
            isForExistingRecord: true,
          },
          {
            targetKey: "sub_type",
            enumValues: ["Vehicle Sale", null],
          },
        ],
        fieldsToEnable: ["sub_type", "unit_analysis_group_code"],
      },
      {
        matches: ["Operating Expense"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: [
              "Sale",
              "Cost Of Sale",
              "Operating Expense",
              "Non-operating Expense",
              "Non-operating Income",
            ],
            isForExistingRecord: true,
          },
          {
            targetKey: "sub_type",
            enumValues: [null],
          },
        ],
        fieldsToEnable: ["unit_analysis_group_code"],
        fieldsToDisableAndClear: ["sub_type"],
      },
      {
        matches: ["Non-operating Income"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: [
              "Sale",
              "Cost Of Sale",
              "Operating Expense",
              "Non-operating Expense",
              "Non-operating Income",
            ],
            isForExistingRecord: true,
          },
          {
            targetKey: "sub_type",
            enumValues: [null],
          },
        ],
        fieldsToDisableAndClear: ["sub_type", "unit_analysis_group_code"],
      },
      {
        matches: ["Non-operating Expense"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: [
              "Sale",
              "Cost Of Sale",
              "Operating Expense",
              "Non-operating Expense",
              "Non-operating Income",
            ],
            isForExistingRecord: true,
          },
          {
            targetKey: "sub_type",
            enumValues: [null],
          },
        ],
        fieldsToEnable: ["unit_analysis_group_code"],
        fieldsToDisableAndClear: ["sub_type"],
      },
      {
        matches: ["Expense Allocation"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: ["Expense Allocation", "Memo"],
            isForExistingRecord: true,
          },
          {
            targetKey: "sub_type",
            enumValues: [null],
          },
        ],
        fieldsToDisableAndClear: [
          "sub_type",
          "unit_analysis_group_code",
          "control_type_code",
          "control2_type_code",
          "productivity_type_code",
          "statistical_count_type_code",
          "is_posting_description_required",
        ],
      },
      {
        matches: ["Memo"],
        fieldsToUpdate: [
          {
            targetKey: "account_type",
            enumValues: ["Expense Allocation", "Memo"],
            isForExistingRecord: true,
          },
        ],
        fieldsToDisableAndClear: ["sub_type", "unit_analysis_group_code"],
      },
      {
        matches: ["", null],
        fieldsToEnable: [
          "sub_type",
          "unit_analysis_group_code",
          "control_type_code",
          "control2_type_code",
          "productivity_type_code",
          "statistical_count_type_code",
          "is_posting_description_required",
        ],
      },
    ],
  },
  sub_type: {
    rules: [
      {
        ruleExclusionCriteria: {
          account_type: {
            matches: ["Expense Allocation", "Equity"],
          },
        },
        matches: [
          "Cash",
          "Vehicle Inventory",
          "Balance-forward Payable",
          "Vehicle Sale",
          null,
        ],
        fieldsToEnable: [
          "control_type_code",
          "control2_type_code",
          "productivity_type_code",
          "statistical_count_type_code",
          "is_posting_description_required",
        ],
      },
      {
        matches: [
          "Balance-forward Receivable",
          "Balance Fwd - Receivable",
          "Open-Item Receivable",
          "Open-Item Payable",
        ],
        fieldsToDisable: [
          "account_type",
          "sub_type",
          "control_type_code",
          "control2_type_code",
          "productivity_type_code",
        ],
      },
      {
        matches: ["Inter-Company"],
        fieldsToDisableAndClear: [
          "control_type_code",
          "control2_type_code",
          "productivity_type_code",
          "statistical_count_type_code",
          "is_posting_description_required",
        ],
      },
    ],
  },
  control_type_code: {
    rules: [
      {
        matches: ["Pattern"],
        fieldsToEnable: ["control_type_pattern"],
      },
      {
        matches: [
          "None",
          "Vehicle Receivable Customer",
          "Vendor",
          "Miscellaneous",
          "A/R Customer",
          "Vehicle",
          "Cash Customer",
          "Salesperson",
          "Service Advisor or Technician",
          "Company",
          "Reference",
          "Required, not validated",
        ],
        fieldsToDisableAndClear: ["control_type_pattern"],
      },
    ],
  },
};

export const MOCK_LASER_FORM_TABLE_DEPENDENCIES: Dependencies = {
  is_micr: {
    rules: [
      {
        matches: [true],
        fieldsToEnable: [
          "micr_routing_no",
          "micr_bank_account_no",
          "micr_check_length",
        ],
      },
      {
        matches: [false],
        fieldsToDisableAndClear: [
          "micr_routing_no",
          "micr_bank_account_no",
          "micr_check_length",
        ],
      },
    ],
  },
};

export const MOCK_ETC_PAY_PERIOD_SCHEMA_DEPENDENCIES: Dependencies = {
  is_overtime_calculated: {
    rules: [
      {
        matches: [true],
        fieldsToEnable: [
          "max_overtime_hours_per_day",
          "max_overtime_hours_per_week",
          "is_pay_ot_for_hours_on_7th_day",
          "is_exclude_prior_week_ot_in_ot_display",
          "is_doubletime_calculated",
        ],
      },
      {
        matches: [false],
        fieldsToDisableAndClear: [
          "max_overtime_hours_per_day",
          "max_overtime_hours_per_week",
          "is_pay_ot_for_hours_on_7th_day",
          "is_exclude_prior_week_ot_in_ot_display",
          "is_doubletime_calculated",
        ],
      },
    ],
  },
  is_doubletime_calculated: {
    rules: [
      {
        matches: [true],
        fieldsToEnable: [
          "max_hours_per_day_before_doubletime",
          "max_hours_on_7th_day_before_doubletime",
        ],
      },
      {
        matches: [false],
        fieldsToDisableAndClear: [
          "max_hours_per_day_before_doubletime",
          "max_hours_on_7th_day_before_doubletime",
        ],
      },
    ],
  },
  is_breaks_compensated: {
    rules: [
      {
        matches: [true],
        fieldsToEnable: ["break_duration"],
      },
      {
        matches: [false],
        fieldsToDisableAndClear: ["break_duration"],
      },
    ],
  },
};

export const MOCK_PO_ROLE_LEVEL_SCHEMA_DEPENDENCIES: Dependencies = {
  is_enabled: {
    rules: [
      {
        matches: [true],
        fieldsToEnable: ["default_amount", "role_level_info"],
      },
      {
        matches: [false],
        fieldsToDisableAndClear: ["default_amount", "role_level_info"],
      },
    ],
  },
};

export const MOCK_DISCOUNTS_DEPENDENCIES: Dependencies = {
  method: {
    rules: [
      {
        matches: ["Fixed price"],
        fieldsToEnable: ["fixed_price"],
        fieldsToDisableAndClear: ["percentage", "target_price", "max_discount"],
      },
      {
        matches: ["Percentage of sales"],
        fieldsToEnable: ["percentage", "max_discount"],
        fieldsToDisableAndClear: ["fixed_price", "target_price"],
      },
      {
        matches: ["Target price"],
        fieldsToEnable: ["target_price", "max_discount"],
        fieldsToDisableAndClear: ["fixed_price", "percentage"],
      },
    ],
  },
  allow_override: {
    rules: [
      {
        matches: [true],
        fieldsToEnable: ["max_override"],
      },
      {
        matches: [false],
        fieldsToDisableAndClear: ["max_override"],
      },
    ],
  },
  warn_min_profitability_cp: {
    rules: [
      {
        matches: [true],
        fieldsToEnable: ["warn_by_cp"],
      },
      {
        matches: [false],
        fieldsToDisableAndClear: [
          "warn_by_cp",
          "min_profit_amount_cp",
          "min_profit_percent_cp",
        ],
      },
    ],
  },
  warn_by_cp: {
    rules: [
      {
        matches: ["Amount"],
        fieldsToEnable: ["min_profit_amount_cp"],
        fieldsToDisableAndClear: ["min_profit_percent_cp"],
      },
      {
        matches: ["Percent"],
        fieldsToEnable: ["min_profit_percent_cp"],
        fieldsToDisableAndClear: ["min_profit_amount_cp"],
      },
      {
        matches: [null],
        fieldsToDisableAndClear: [
          "min_profit_amount_cp",
          "min_profit_percent_cp",
        ],
      },
    ],
  },
  warn_min_profitability_ip: {
    rules: [
      {
        matches: [true],
        fieldsToEnable: ["warn_by_ip"],
      },
      {
        matches: [false],
        fieldsToDisableAndClear: [
          "warn_by_ip",
          "min_profit_amount_ip",
          "min_profit_percent_ip",
        ],
      },
    ],
  },
  warn_by_ip: {
    rules: [
      {
        matches: ["Amount"],
        fieldsToEnable: ["min_profit_amount_ip"],
        fieldsToDisableAndClear: ["min_profit_percent_ip"],
      },
      {
        matches: ["Percent"],
        fieldsToEnable: ["min_profit_percent_ip"],
        fieldsToDisableAndClear: ["min_profit_amount_ip"],
      },
      {
        matches: [null],
        fieldsToDisableAndClear: [
          "min_profit_amount_ip",
          "min_profit_percent_ip",
        ],
      },
    ],
  },
  warn_min_profitability_wp: {
    rules: [
      {
        matches: [true],
        fieldsToEnable: ["warn_by_wp"],
      },
      {
        matches: [false],
        fieldsToDisableAndClear: [
          "warn_by_wp",
          "min_profit_amount_wp",
          "min_profit_percent_wp",
        ],
      },
    ],
  },
  warn_by_wp: {
    rules: [
      {
        matches: ["Amount"],
        fieldsToEnable: ["min_profit_amount_wp"],
        fieldsToDisableAndClear: ["min_profit_percent_wp"],
      },
      {
        matches: ["Percent"],
        fieldsToEnable: ["min_profit_percent_wp"],
        fieldsToDisableAndClear: ["min_profit_amount_wp"],
      },
      {
        matches: [null],
        fieldsToDisableAndClear: [
          "min_profit_amount_wp",
          "min_profit_percent_wp",
        ],
      },
    ],
  },
  applies_to: {
    rules: [
      {
        matches: ["Both labor and parts", ""],
        fieldsToEnable: [
          "split_by_cp",
          "split_by_ip",
          "split_by_wp",
          "use_labor_type_accounts_cp",
          "use_labor_type_accounts_ip",
          "use_labor_type_accounts_wp",
        ],
        coRelationParentsToEnable: [
          "labor_accounts_cp",
          "labor_accounts_ip",
          "labor_accounts_wp",
          "parts_accounts_cp",
          "parts_accounts_ip",
          "parts_accounts_wp",
        ],
      },
      {
        matches: ["Labor"],
        fieldsToDisableAndClear: [
          "split_by_cp",
          "split_by_ip",
          "split_by_wp",
          "use_labor_type_accounts_cp",
          "use_labor_type_accounts_ip",
          "use_labor_type_accounts_wp",
        ],
        coRelationParentsToEnable: [
          "labor_accounts_cp",
          "labor_accounts_ip",
          "labor_accounts_wp",
        ],
        coRelationParentsToEmptyArray: [
          "parts_accounts_cp",
          "parts_accounts_ip",
          "parts_accounts_wp",
        ],
      },
      {
        matches: ["Parts"],
        fieldsToDisableAndClear: [
          "split_by_cp",
          "split_by_ip",
          "split_by_wp",
          "use_labor_type_accounts_cp",
          "use_labor_type_accounts_ip",
          "use_labor_type_accounts_wp",
        ],
        coRelationParentsToEnable: [
          "parts_accounts_cp",
          "parts_accounts_ip",
          "parts_accounts_wp",
        ],
        coRelationParentsToEmptyArray: [
          "labor_accounts_cp",
          "labor_accounts_ip",
          "labor_accounts_wp",
        ],
      },
    ],
  },
};
